import { Dot } from "./dot";
import { Channel } from "./channel";
import { Stat } from "./stat";

export class Stats {
    actualBudget: number;
    budget: number
    channels: Array<Channel>;
    coop: number;
    cpl: Stat;
    cps: Stat;
    expenses: number;
    leads: Stat;
    sales: Stat;
    sessions: Stat;
    totalLessCoop: number;
    variance: number;
    constructor (data) {
        this.actualBudget =  data.actualBudget;
        this.budget =  data.budget;
        this.channels =  data.channels.map(item => new Channel(item));
        this.coop =  data.coop;
        this.cpl = new Stat(data.cpl);
        this.cps = new Stat(data.cps); 
        this.expenses =  data.expenses;
        this.leads = new Stat(data.leads); 
        this.sales = new Stat(data.sales); 
        this.sessions = new Stat(data.sessions); 
        this.totalLessCoop =  data.totalLessCoop;
        this.variance =  data.variance;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/stats/stats.ts